// extracted by mini-css-extract-plugin
module.exports = {"container":"Voter_container__1VsGb","upVote":"Voter_upVote__w1pH7","downVote":"Voter_downVote__2EBaL"};